module.exports = __webpack_public_path__ + "static/img/QRCode1.0aee097f.png";